<div class="m-4">
  Please send us an email to soporte@bonavidawellness.com if you want to delete
  your account or any data associated with your account.
</div>
